import { useEffect, useState } from '../lib/teact/teact';

// Fixes input lag caused by re-running heavy work on every keystroke, especially in Safari on iOS.
// Returns a trailing-debounced copy of `value` so consumers recompute after typing pauses, not on every change.
export default function useDebouncedValue<T>(value: T, ms: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const timeout = window.setTimeout(() => setDebouncedValue(value), ms);
    return () => window.clearTimeout(timeout);
  }, [value, ms]);

  return debouncedValue;
}
